import { X } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PunchupConfirmDialog } from 'features/common/components/Punchup/composites/dialogs/PunchupConfirmDialog';

interface CancelModalProps {
	onConfirm: () => void;
	onClose: () => void;
	isLoading: boolean;
	isDestructive?: boolean;
}

export const CancelModal: FC<CancelModalProps> = ({ onConfirm, onClose, isLoading, isDestructive = true }) => {
	const { t } = useTranslation();
	return (
		<PunchupConfirmDialog
			icon={<X size={24} />}
			iconVariant="destructive"
			title={t('attendee-actions-cancel-ticket', 'Cancel Ticket')}
			text={t(
				'attendee-actions-cancel-confirm',
				'This ticket will be voided and the attendee will lose access to the event.'
			)}
			secondaryText={t(
				'attendee-actions-cancel-secondary',
				'No refund is issued when cancelling manually. The freed seat becomes available for other buyers to purchase immediately. You can reverse this at any time using Un-Cancel Ticket.'
			)}
			collapsibleSecondary
			isLoading={isLoading}
			isDestructive={isDestructive}
			buttons={[
				{ label: t('cancel', 'Cancel'), variant: 'secondary', onClick: onClose },
				{ label: t('confirm', 'Confirm'), variant: 'destructive', onClick: onConfirm },
			]}
		/>
	);
};
